import * as React from "react";
import { styled } from "@mui/material/styles";
import { Typography, TextField } from "@mui/material";

const PREFIX = "SaveNameInput";

const classes = {
  pgcNameField: `${PREFIX}-pgcNameField`,
  modalHeaderText: `${PREFIX}-modalHeaderText`,
};

const Root = styled("div")({
  [`& .${classes.pgcNameField}`]: {
    marginBottom: "1rem",
  },
  [`& .${classes.modalHeaderText}`]: {
    paddingBottom: 0,
  },
  width: "fit-content",
});

interface Props {
  value: string;
  onChange: (value: string) => void;
  header: string;
  errors?: boolean;
  errorText?: string;
  width?: "small" | "large" | "medium";
  displayTextField?: boolean;
}

export default function SaveNameInput({
  value,
  onChange,
  header,
  errors,
  errorText,
  width,
  displayTextField,
}: Props) {
  const getWidth = () => {
    const values = {
      small: 200,
      medium: "95%",
      large: 600,
    };
    return width ? values[width] : 450;
  };
  return (
    <Root id="rootSaveNameInput">
      <Typography
        variant="body2"
        color="primary.main"
        className={classes.modalHeaderText}
      >
        <b>{header}</b> {!displayTextField && "(shorter names display better)"}
      </Typography>
      {!displayTextField && (
        <TextField
          size="small"
          margin="dense"
          style={{ width: getWidth() }}
          className={classes.pgcNameField}
          label="Enter Name"
          variant="outlined"
          value={value}
          error={errors}
          onChange={(e: any) => onChange(e.target.value)}
          helperText={errorText}
          id="input-name-field"
        />
      )}
    </Root>
  );
}
